// DashboardInterviews.jsx

import React from "react";
import InterviewDashboard from "../../InterviewDashboard";
import { createUseStyles } from "react-jss";

function DashboardInterviews({
  interviews,
  getData,
  setFinalData,
  finalData,
}) {
  const styles = useStyles();

  const changeDate = (value) => {
    if (!value) return;

    const updatedFinalData = {
      ...finalData,
      interviewDate: value?.format("YYYY-MM-DD"),
    };

    setFinalData(updatedFinalData);
    getData(updatedFinalData);
  };

  return (
    <section className={styles.wrapper}>
      <InterviewDashboard
        records={interviews}
        changeDate={changeDate}
        defaultDate={finalData?.interviewDate}
      />
    </section>
  );
}

export default DashboardInterviews;

const useStyles = createUseStyles({
  wrapper: {
    background: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: 24,
    boxShadow: "0 10px 30px rgba(15,23,42,0.06)",
    overflow: "hidden",
    width: "100%",
    transition: "all 0.22s ease",
    marginTop: 20,
    "&:hover": {
      boxShadow: "0 14px 36px rgba(15,23,42,0.08)",
    },
  },
});